<template>
  <div>
    <portal to="page-top-title">New Badword</portal>
    <portal to="page-top-right"></portal>

    <box-form action="create" data-prop="formData" url="/badwords" redirect="badwords-list" loader>
      <template slot="content">
        <row>
          <column-input>
            <form-group-input name="value" :model="formData.value" :min="2" required/>
          </column-input>
          <column-input>
            <form-group-select name="category_id" title="Category" :model="formData.category_id"
                               :options="categories" :disabled="!categories.length" required/>
          </column-input>
          <column-input :md="2">
            <form-group-check name="active" :model="formData.active"/>
          </column-input>
        </row>
      </template>
    </box-form>
  </div>
</template>

<script>
import BoxForm from '@/views/components/data/BoxForm'
import FormGroupInput from '@/views/components/form/FormGroupInput'
import FormGroupCheck from '@/views/components/form/FormGroupCheck'
import FormGroupSelect from '@/views/components/form/FormGroupSelect'
import Form from '@/modules/utils/Form'

export default {
  name: 'BadwordsNew',
  metaInfo () {
    return { title: 'Badwords | New' }
  },
  components: {
    BoxForm,
    FormGroupInput,
    FormGroupCheck,
    FormGroupSelect
  },
  data () {
    return {
      formData: {
        value: Form.types.input(),
        category_id: Form.types.select(),
        active: Form.types.boolean(true)
      },
      categories: []
    }
  },
  created () {
    this.loadCategories()
  },
  methods: {
    loadCategories () {
      this.$http
        .get('/badwords/categories', { params: { no_pages: 1, active: 1 } })
        .then((res) => {
          const { data: { data } } = res

          this.categories = data.map((category) => { return { id: category.id, name: category.name } })

          this.categoryCheckSelected()
        })
    },
    categoryCheckSelected () {
      const queryCatId = Number(this.$route.query.category)

      if (isNaN(queryCatId)) return

      const category = this.categories.find((category) => category.id === queryCatId)

      if (category) this.formData.category_id = Form.types.select(category)
    }
  }
}
</script>
